/* global Q, nf, Element, BRAC, NodeList, HTMLCollection */
;
(function () {
    sin = 'sin';

    var _trz = function (el, prop, val, dur, cb, tif, delay) {
        //  console.trace(arguments)
        // init cssText & more if case
        // console.log("###",el,el.parent);
        _trz.init(el);

        // avoid using string as function
        if (typeof cb !== 'function')
            cb = nf;
        cb = cb.bind(el); // assure any further method will know who is element target
        //log([prop,el.style[prop]])
        if (el.style[prop] === ''/*&&/width|height|left|top/.test(prop)*/) {
            el.fix(prop);
            if (el.style[prop] !== '') {
                _trz(el, prop, val, dur, cb, tif, delay);
                return;
            }
        }


        // for complex animations
        if (['sin', 'etc'].has(tif)) {
            //console.log("COMPLEX"+ " : "+prop)
            _trz.complex(tif, arguments);
            return;
        }

        //console.log(arguments);
        var startTime = Date.now();

        //    if(prop=='transform') {
        //        val=inherit_transform(el,val);
        //    }
        val = _trz.proc_val(el, prop, val);

        // reject non necesarry  animation final==start        
        if (val === ""
            //el.computed(prop) === val || val === ""
        ) {
            //  console.log(el,el.id,"REJECT "+prop+" : " + val)//+ " from "+ el.css());
            return;
        }

        prop = if_brac(prop);// necesar  Safari iOS -webkit-transform


        var t = !!dur ? (parseFloat(dur) || { slow: .8, mid: .05 }[dur]) : .2;
        if (t > 10) { // argument time in milisecunde
            t = t / 1000;
        }



        var transition_text = prop + " " + t + "s" + " " +
            (_trz.beziers[tif] || tif || 'ease-in-out') + " " +
            (parseFloat(delay) || 0) + "s";
        var initial_css = el.style.cssText;


        if (initial_css.indexOf('transition') < 0) {
            el.style.cssText += ';' + if_brac("transition") + ":" + transition_text;// first transition	
        }
        else {
            el.style.cssText = initial_css.replace(/([^;]*transition[^;]*)/gi, '$1' + ', ' + transition_text); /* !BAC-1*/
        }
        //log(el.style.cssText)

        if (el.active_trans[prop]) { // intreruption from same prop transition                                
            el.REL(_trz.END, el.active_trans[prop]);
            //delete el.active_trans[prop];
            // el.fire(_trz.END);
        }



        // handler add event listener that cleans itself for transitionend		
        function reaction(e) {
            //Q.inspect(e);
            //console.log([e.propertyName,prop]) 
            if ((e.propertyName !== prop || el !== e.target))
                return; // reject events from other elements and other properies
            /* !BAC-1*/

            var reg = new RegExp(prop +
                "(([^:]+\\(.*?\\).*?[,;])" + // cauta chestii gen    left 1s cubic-bezier(0.141.59,0.47,0.99) 0s in coada cu [,;] 
                "|" +
                "([^:]+?[,;]))", "gi");      // cauta chestii gen   left 1s ease-in 0s in coada cu [,;]

            //             
            var replacement = el.style.cssText.replace(reg, function (x) {
                return x.indexOf(';') > 0 ? ';' : '';
            }).replace(/,\s*;/gi, ';');
            //console.log("REPLACEMENT|"+replacement.match(/transition.*/)[0]); //

            el.style.cssText = replacement;
            el.REL(_trz.END, reaction);
            delete el.active_trans[prop];

            //console.log("FINISED : "+prop+" "+(Date.now()-startTime)/1000+"s");

            el.chain instanceof Function ? el.chain() : el.fire('trz_end');



            // CALLBACKS 

            //cb(el);
            setTimeout(function () {
                cb(el);
            }, 0); // cica asa ar fi  asynchron

            //var st=el.stack.pop();

        }

        el.AEL(_trz.END, reaction);
        el.active_trans[prop] = reaction;
        el.css(prop + ":" + val + ";");
    };
    Q.trz = _trz;
    _trz.complex = function () {
        var a = arguments[1];       //a[0]=el,a[1]=prop,a[2]=val,a[3]=time,a[4]=cb,a[5]=tif,a[6]=delay           
        switch (arguments[0]) {
            case 'sin':
                { // loop animation 
                    var time = a[3] / 2;
                    var from_prop;
                    var p = camelize(if_brac(a[1]));
                    if (!(p in a[0].start_val)) {
                        if (!a[0].style[p])
                            a[0].style[p] = a[0].computed(p);
                        a[0].start_val[p] = from_prop = a[0].style[p];
                    }
                    else
                        from_prop = a[0].start_val[p];
                    var cb = function () {
                        _trz(a[0], a[1], from_prop, time, function () {
                            delete a[0].start_val[p];
                            a[4](a[0]);
                        }, "ease-in-out");
                    };
                    // console.log("RUNING :   _trz("+a[0]+","+a[1]+","+a[2]+","+time+","+(a[4]||"\'\'")+","+"ease-in-out"+","+(a[6]||",\'\'")+")");
                    // console.log("CALLBACK : _trz("+a[0]+","+a[1]+","+from_prop+","+time+","+(a[4]||"\'\'")+","+"ease-in-out"+",\'\')");
                    setTimeout(function () {
                        _trz(a[0], a[1], a[2], time, cb, 'ease-in-out', a[6]);
                    });
                }
                ;
                break
        }
    };

    _trz.init = function (el) {
        if (!('active_trans' in el)) {
            el.active_trans = {};
            el.start_val = {};// necesar pt tipul sin - evita errory pt lansarea multipla a aceleiasi animatii de pe un button
            el.stack = []; // chain animation
            el.trf = {};
            var extracted = el.style[camelize(if_brac('transform'))] || '';
            extracted = extracted.replace(/\s*none/gim, '');
            var t = { translate: [0, 0], rotateX: 0, rotateY: 0, rotateZ: 0, scale: 1, skew: 0 };
            for (var i in t) {
                if (extracted.indexOf(i) < 0) {
                    if (i === 'translate') {
                        extracted += " " + i + "(" + t[i][0] + "px," + t[i][1] + "px)";
                    } else {
                        extracted += " " + i + "(" + t[i] + (i.indexOf('rotate') === 0 ? "deg" : "") + ")";
                    }
                }
                el.trf[i] = t[i];
            }
            el.css(if_brac('transform') + ":" + extracted + ";");
        }
    };




    _trz.END = {
        Moz: 'transitionend',
        webkit: 'webkitTransitionEnd',
        o: 'oTransitionEnd',
        ms: 'transitionend'
    }[BRAC];

    _trz.beziers = { 'lili': "cubic-bezier(.17,.67,1,.69)", 'boing': "cubic-bezier(.14,1.59,.47,.99)", "ding": "cubic-bezier(.55,1.30,.77,.99)" };


    _trz.proc_val = function (el, prop, val) {
        if (prop === 'transform') {
            val = inherit_transform(el, val);
        }
        else if (/@/.test(val)) {
            var to = (new RegExp(prop + "\\s*:\\s*(-?[\\d\\.]*)([^\\s\\;]*)", "i")).exec(el.style.cssText);
            val = ((parseFloat(to[1]) || 0) + (parseFloat(/@(-?[\d\.]*)/.exec(val)[1]) || 0)) + to[2];
        }
        return val;
    };

    inherit_transform = function (el, val) {
        var extracted = el.style[camelize(if_brac('transform'))];
        //console.log(extracted)
        // if(extracted===''||extracted==='none') "translate(0,0) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(1) skew(0deg) ";   
        var vals = val.match(/[^\s]*?\(.*?\)/gim).map(function (p) {
            return p.replace(/\s*/gim, '');
        });
        var M = 0;
        for (var i in vals) {
            var vreg = new RegExp(vals[i].split('(')[0] + "\\(.*?\\)", "gim");
            // console.log(vreg);
            extracted = extracted.replace(vreg, function (x) {
                //console.log([vreg,x,vals[i]])
                if (x.replace(/\s*/gim, '') !== vals[i])
                    ++M;
                return vals[i];
            });
        }
        return M ? extracted : "";
    };







    Element.prototype.morf = function () {
        var a = arguments, N = 0;

        if (typeof arguments[0] === 'object') {
            // EX:   el.morf( {height:"300px",opacity:.5},1,dn,sin,1 )
            for (var p in a[0]) {
                var cb = !N++ ? a[2] : nf;
                _trz(this, p, a[0][p], a[1], cb, a[3], a[4], a[5]);
            }
        }
        else {
            a[0] ? _trz(this, a[0], a[1], a[2], a[3], a[4], a[5])  // positional arguments
                : this.style[camelize(if_brac('transition'))] = null;// resetare animatii (clean)
        }
        return this;
    };




    //simplified transformations
    Element.prototype.fade = function (a, b, c, d, e) {
        _trz(this, 'opacity', a, b, c, d, e);
        return this;
    };
    Element.prototype.bg_color = function (a, b, c, d, e) {
        _trz(this, 'background-color', a, b, c, d, e);
        return this;
    };


    Element.prototype.rotate3d = function (a, b, c, d, e, xyz) {
        _trz.init(this);
        var add = /@/.test(a);
        var a = add ? (this.ang || 0) + parseFloat(a.substr(1)) : parseFloat(a);
        this.ang = a;
        if (d !== sin) {
            this.trf['rotate' + xyz] = a;
        }
        _trz(this, 'transform', 'rotate' + xyz + '(' + a + 'deg)', b, c, d, e);
        return this;
    };
    Element.prototype.roll = function (a, b, c, d, e) {
        this.rotate3d(a, b, c, d, e, "X");
        return this;
    };
    Element.prototype.flip = function (a, b, c, d, e) {
        this.rotate3d(a, b, c, d, e, "Y");
        return this;
    };
    Element.prototype.spin = function (a, b, c, d, e) {
        this.rotate3d(a, b, c, d, e, "Z");
        return this;
    };

    // non animated rotation

    Element.prototype.rotate = function (ang) {
        var val = "rotateZ(" + parseFloat(ang) + "deg)";
        var old = this.style[camelize(if_brac('transform'))];
        var rpl = /rotateZ/.test(old) ? old.replace(/rotateZ[^\)]*\)/gi, val) : val;
        this.style[(if_brac('transform'))] = rpl;
        return this;
    };


    // transform-origin ignores padding and margin -- is a separate css property then transform
    Element.prototype.origin = function (s, ignore_translations) {
        this.css(if_brac("transform") + "-origin:" + s);
        if (!ignore_translations) {
            _trz.init(this);
            var org = this.computed(if_brac("transform") + "-origin").split(" ");
            this.css(if_brac("transform") + "-origin:" + (this.trf.translate[0] + parseFloat(org[0])) + "px " + (this.trf.translate[1] + parseFloat(org[1])) + "px");
        }
        //console.log(this.computed(if_brac("transform")+"-origin"));
        return this;
    };
    Element.prototype.toXY = function (a, b, c, d, e) {
        _trz.init(this);
        var
            a = typeof a === 'string' ? a.split(",") : a,
            x = /@/.test(a[0]) ? (this.trf.translate[0] || 0) + (parseFloat(a[0].substr(1)) || 0) : parseFloat(a[0]) || 0,
            y = /@/.test(a[1]) ? (this.trf.translate[1] || 0) + (parseFloat(a[1].substr(1)) || 0) : parseFloat(a[1]) || 0;

        if (d !== sin) {
            this.trf.translate[0] = x;
            this.trf.translate[1] = y;
        }
        // console.log(x,y,this.trf.translate)

        _trz(this, "transform", "translate(" + x + "px, " + y + "px )", b, c, d, e);
        return this;
    };




    /// !!!BAC --- ?????? batalie cu MATRIX3D ?????????? tre sa ma ocup de omogenizare   ---- 
    Element.prototype.scale = function (a, b, c, d, e) {
        if (0 && /matrix/.test(this.style.transform)) { //!!BAC nu merge animat 
            var M = this.matrix;
            M[0] = M[5] = a;
            //console.log("matrix3d(" + M.join(",") + ")");
            _trz(this, 'transform', "matrix3d(" + M.join(",") + ")", b, c, d, e);

        }
        else {
            _trz(this, 'transform', 'scale(' + a + ')', b, c, d, e);
        }
        return this;
    };




    "use strict";
    var common_animations = {
        slideX: ['left'],
        slideY: ['top'],
        resizeH: ['height'],
        resizeW: ['width'],
        radius: ['border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius'],
        margin: ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
        padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"]
    };

    for (var k in common_animations) {
        (function (prop) {
            var spr_prop = common_animations[prop];
            Element.prototype[prop] = function (val, time, cb, bz, dl) {
                var add = /@/.test(val);
                var N = 0;
                for (var s in spr_prop) {
                    var v = this.computed(spr_prop[s]);
                    v = add ? ((parseInt(v) || 0) + parseInt(val.substr(1))) + 'px' : parseInt(val) + 'px';
                    var cbs = !N++ ? cb : nf;
                    _trz(this, spr_prop[s], v, time, cbs, bz, dl);
                }
                return this;
            };
        })(k);
    }
})();

(function () {
    // NodeList getting Element.prototype methods
    var nodized_methods = ['setA', 'remA', 'togA', 'getA', 'tmpA', 'setC', 'remC', 'hasC', 'die', 'css', 'drag', 'undrag', 'dragParent', 'undragParent', 'morf', 'fade', 'bg_color', 'spin', 'scale', 'toXY', 'resizeW', 'resizeH', 'AEL', 'REL', 'tog', 'wrap', 'pin', 'shup', 'fix', 'next', 'prev', 'parent', 'on', 'off'];
    nodized_methods.forEach(
        function (name) {
            HTMLCollection.prototype[name] = NodeList.prototype[name] = function () {
                for (var i = 0; i < this.length; i++) {
                    Element.prototype[name].apply(this[i], arguments);
                }
                return this;
            };
        }
    );


})();


Element.prototype.map = function (x) { // pt Q("#id") care 
    try {
        x(this);
    } catch (err) {
        (new Function('e', 'x(e)'))(this);
    }
    ;
    return this;
};




/**
 * AM timpuri de animatie
 * CSS - trasition  --  easing functions
 * 
 * CSS - animation  --  keyframes and easing for every step
 * 
 *  js - EP.animate -- native
 *  js.custom animation 
 */










/**
 * Helper: Smoothly scroll an ancestor container to center the given item in view
 * @param {Element} item - Element to scroll into view
 * @param {Element} anc - Ancestor container with scroll capability
 */
function scrollIntoAncestorViewIfNeeded(item, anc) {
    // Get bounding rectangles of item and ancestor
    const ir = item.getBoundingClientRect();
    const ar = anc.getBoundingClientRect();

    // If item is already fully visible within ancestor bounds, skip scrolling
    if (ir.top >= ar.top && ir.bottom <= ar.bottom) {
        return;
    }

    // Calculate scroll offset to center item within ancestor viewport
    anc.scrollTo({
        top:
            anc.scrollTop +                  // Current scroll position
            (ir.top - ar.top) -              // Item position relative to ancestor top
            (anc.clientHeight / 2) +         // Offset to center vertically
            (ir.height / 2),                 // Account for item height
        behavior: 'smooth'                   // Animate the scroll
    });
}

/**
 * Scroll this element into view within its nearest scrollable ancestor
 * @param {Element} [anc] - Optional specific ancestor to scroll. If omitted, auto-detect
 */
EP.scrollIntoAncestor = function (anc) {
    // If specific ancestor provided, scroll into it and return
    if (anc) {
        scrollIntoAncestorViewIfNeeded(this, anc);
        return;
    }

    // Walk up DOM tree to find scrollable ancestor
    let p = this.parentElement;
    while (p) {
        const s = getComputedStyle(p);
        // Check if ancestor has vertical scroll AND content overflows
        if (
            /(auto|scroll|overlay)/.test(s.overflowY) &&  // Scrollable Y axis
            p.scrollHeight > p.clientHeight                // Content exceeds container
        ) {
            scrollIntoAncestorViewIfNeeded(this, p);
        }
        p = p.parentElement;
    }
};








